import {
    LOGIN_USER,
    LOGIN_SUCCESS,
    LOGIN_PERMISSION,
    LOGOUT_USER,
    LOGOUT_USER_SUCCESS,
    API_ERROR,
    SOCIAL_LOGIN,
    RESET_LOGIN_FLAG,
    GET_IP,
    GET_IP_SUCCESS,
    GET_IP_ERROR,
    LOGIN_USER_INFO,
} from "./actionTypes";

export const loginUser = (user, history) => {
    return {
        type: LOGIN_USER,
        payload: { user, history },
    };
};

export const getIp = () => {
    return {
        type: GET_IP,
        payload: {},
    };
};

export const getIpSuccess = (data) => {
    return {
        type: GET_IP_SUCCESS,
        payload: data,
    };
};

export const getIpError = () => {
    return {
        type: GET_IP_ERROR,
        payload: {},
    };
};


export const loginSuccess = (user) => {
    return {
        type: LOGIN_SUCCESS,
        payload: user,
    };
};

export const loginPermission = (user) => {
    return {
        type: LOGIN_PERMISSION,
        payload: {},
    };
};

export const logoutUser = (history) => {
    return {
        type: LOGOUT_USER,
        payload: { history },
    };
};

export const logoutUserSuccess = () => {
    return {
        type: LOGOUT_USER_SUCCESS,
        payload: {},
    };
};

export const apiError = (error) => {
    return {
        type: API_ERROR,
        payload: error,
    };
};

export const socialLogin = (data, history, type) => {
    return {
        type: SOCIAL_LOGIN,
        payload: { data, history, type },
    };
};

export const resetLoginFlag = () => {
    return {
        type: RESET_LOGIN_FLAG,
    };
};

export const loginUserInfo = (data) => {
    return {
        type: LOGIN_USER_INFO,
        payload: data,
    };
};
